import { accountApi } from "../config/apiConfig";

export interface ChatbotAnalytics {
  month: string;
  uniqueUsersThisMonth: number;
  totalSessionsThisMonth: number;
  sessionCap: number;
  sessionsRemaining: number;
  usersAtDailyLimit: number;
  topUsers: Array<{ userEmaid: string; sessionsThisMonth: number }>;
}


export const getChatbotAnalytics = async (
  month?: string
): Promise<ChatbotAnalytics> => {
  const params = month ? { month } : {};
  const response = await accountApi.get("/chatbot/analytics", { params });
  return response.data;
};

export const setChatbotBudget = async (
  budgetEur: number,
  month?: string
): Promise<void> => {
  const body: { budget_eur: number; month?: string } = { budget_eur: budgetEur };
  if (month) body.month = month;
  await accountApi.patch("/chatbot/budget", body);
};
